module.exports = __webpack_public_path__ + "img/que_1.7cc7699d.png";